import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const auth = {
  username: process.env.VUE_APP_USERNAME,
  password: process.env.VUE_APP_PASSWORD,
};

export default new Vuex.Store({
  state: {
    site: [],
    home: [],
    pages: [],
    cart: [],
  },
  getters: {
    getProjectByUID:
      (state) =>
      (uid, collection = state.projects) => {
        let i = collection.length;
        while (i--) {
          if (collection[i].uid === uid) {
            return collection[i];
          }
        }
      },
    totalAmount: (state) => {
      let amount = 0;
      state.cart.forEach((item) => (amount += item.price * item.quantity));
      return amount;
    },
    totalItems: (state) => {
      let amount = 0;
      state.cart.forEach((item) => (amount += item.quantity));
      return amount;
    },
  },
  actions: {
    async loadSite({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "site",
            select: {
              title: true,
              url: true,
              menu: {
                query: "site.children.listed",
                select: {
                  title: true,
                  uid: true,
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_SITE", response.data.result);
        });
    },
    async loadHome({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('home')",
            select: {
              title: true,
              uid: true,
              featured: {
                query: "page.featured.toPages",
                select: {
                  title: true,
                  uid: true,
                  description: "page.description.kirbytext",
                  views: {
                    query: "page.views.toStructure",
                    select: {
                      name: true,
                    },
                  },
                  stock: {
                    query: "page.stock.toStructure",
                    select: {
                      color: true,
                      colorname: true,
                      showcolorname: "structureItem.showcolorname.toBool",
                      size: true,
                      stock: true,
                      preorder: "structureItem.preorder.toBool",
                      launch: true,
                      message: true,
                    },
                  },
                  price: true,
                  images: {
                    query: "page.files",
                    select: {
                      srcset: "file.srcset([400, 800, 1200, 1600, 2000])",
                      thumb: "file.resize(100).url",
                      url: true,
                      type: true,
                      view: true,
                      colour: true,
                    },
                  },
                },
              },
            },
          },
          { auth }
        )
        .then(function (response) {
          commit("SET_HOME", response.data.result);
        });
    },
    async loadPage({ commit }, payload) {
      await axios
        .get(`/api/layout/${payload}`, { auth })
        .then(function (response) {
          commit("SET_PAGE", response.data);
        });
    },
  },
  mutations: {
    SET_SITE(state, data) {
      state.site = data;
    },
    SET_HOME(state, data) {
      state.home = data;
    },
    SET_PAGE(state, data) {
      state.pages[data.uid] = data;
    },
    addToCart({ cart }, product) {
      const itemIndex = cart.findIndex((item) => item.id === product.id);
      if (itemIndex < 0) {
        cart.push(product);
      } else {
        cart[itemIndex].quantity++;
      }
    },
    removeFromCart({ cart }, productid) {
      const itemIndex = cart.findIndex((item) => item.id === productid);
      cart.splice(itemIndex, 1);
    },
    decreaseItem({ cart }, productid) {
      const itemIndex = cart.findIndex((item) => item.id === productid);
      cart[itemIndex].quantity--;
    },
    increaseItem({ cart }, productid) {
      const itemIndex = cart.findIndex((item) => item.id === productid);
      cart[itemIndex].quantity++;
    },
  },
});
